/**
 @ngdoc directive
 @name xmsSmarterTable

 @description
 Will place a table into the page, with pre-built filters.
 The table's columns and rows are generated by JSON data.
 Important Note: For filter table to work it must collect the full data set.
 Therefore this solution may not be sensible for very large data sets or poor performing data collections
 The table will either collect the data upon a button click or auto collect the date upon being rendered

 @usage
 <xms-smarter-table url=""></xms-smarter-table>

 @param {string}  url                       - Url to collect the JSON data from
 @param {object}  params-model              - (optional) Angular model values to be passed as part of the JSON data collection
 @param {boolean} debug                     - (optional) will provide console and model boxes to aid debugging issues
 @param {string}  type                      - (optional) 'auto'|'search' Which mode type auto will instantly collect the data, search will provide a button for end user to collect the data
 @param {boolean} cell-cache                - (optional) Will cache the cell's formatted value and filter comparision value
 @param {boolean} has-actions               - (optional) Will display actions column
 @param {boolean} has-checkbox              - (optional) Will display checkbox column
 @param {boolean} highlight-actions-row     - (optional) Will highlight rows with actions or checkboxes on them
 @param {string}  global-action-url           - (optional) Url to redirect when we click on the global actions

 */
(function () {
    'use strict';
    var xmsSmarterTable = function ($compile,$templateCache,logService,i18nService,ajaxCall,filterDataService) {
        return {
            restrict: 'E',
            scope: false,
            bindToController: {
                //reminder [ '@':'one-way binding', '=':'two-way binding', '=?':'two-way binding optional', '&':'literal binding' ]
                url: '@',
                paramsModel: '=?',
                debug: '=?',
                type: '@?',
                cellCache: '=?',
                hasActions: '=?',
                hasCheckbox: '=?',
                highlightActionsRow: '=?',
                isDownloadable: '=?',
                globalActionUrl: '@?'
            },
            controllerAs: 'ctrl',
            controller: function () {
                var logObj = logService.init('xmsSmarterTable',false);
                var _this = this;

                //this.downloadFilenameFiltered = 'hello';
                /**
                 * Set of ajax state options to signify the AJAX requests state
                 * @type {{PAUSED: string, LOADING: string, LOADING_PROGRESS: string, COMPLETED: string, FAILED: string}}
                 */
                var ajaxStateOption = {
                    PAUSED:'PAUSED',LOADING:'LOADING',LOADING_PROGRESS:'LOADING_PROGRESS',COMPLETED:'COMPLETED',FAILED:'FAILED'
                };

                /**
                 *
                 * @param bool
                 * @param boolDefault
                 * @returns {boolean}
                 */
                var toBoolean = function(bool, boolDefault){
                    if(bool!=undefined)
                        return bool;
                    else
                        return boolDefault;
                };

                /**
                 * Sets up teh i18n part of the directive
                 */
                var setupI18n = function(){
                    //Pre load all our i18n values for speed and efficiency
                    _this.i18nService = i18nService.preLoadI18nValues({
                        'default.button.search.label': 'Search',
                        'spinner.alt': 'Loading...',
                        'default.actions.label': 'Actions',
                        'default.filterTable.sortBy.label': 'Sort by {0}',
                        'default.filterTable.filterCondition.label': 'Filter condition',
                        'default.filterTable.filterValue.label': 'Filter value',
                        'default.filterTable.clearFilter.label': 'Clear filter',
                        'default.filterTable.clear.button': '×',
                        'default.filterTable.download.filter.button': 'Filtered {0} Rows',
                        'default.filterTable.download.all.button': 'All {0} Rows',
                        'default.filterTable.downloadSomething.button': 'Download {0}'
                    });
                    logObj.log('i18nService', i18nService);
                };

                /**
                 * Sets up each attribute with any defaults
                 */
                var setupAttrs = function(){
                    //var _this = this;
                    _this.debug                  = toBoolean(_this.debug,false);
                    _this.type                   = _this.type?_this.type:'search';
                    _this.cellCache              = toBoolean(_this.cellCache,true);
                    _this.hasActions             = toBoolean(_this.hasActions, true);
                    _this.hasCheckbox            = toBoolean(_this.hasCheckbox,true);
                    _this.highlightActionsRow    = toBoolean(_this.highlightActionsRow,false);
                    _this.isDownloadable         = toBoolean(_this.isDownloadable,false);

                    //Set up debug options
                    logObj.debug = _this.debug;

                    logObj.logMap({
                        'debug': _this.debug, 'type': _this.type, 'url': _this.url, 'params-model': _this.paramsModel,
                        'cell-cache': _this.cellCache, 'has-actions': _this.hasActions,
                        'has-checkbox': _this.hasCheckbox, 'highlight-actions-row': _this.highlightActionsRow
                    });

                    _this.ajaxState = ajaxStateOption.PAUSED;
                    //Set up more debug
                    filterDataService.setDebug(_this.debug);

                    //run the search - worth noting doesn't work with dat field due to them not being instantiated quickly
                    if(_this.type=='auto'){
                        _this.getSearchData();
                    }
                };

                //dataCollection
                /**
                 * Calling this will run an AJAX post request, to the provided searchURL passing a provided ng model as searchParams for that request.
                 * Example: <button type="button" class="btn btn-primary" ng-click="getSearchData('${searchUrl}',formModel)"><g:message code="default.button.search.label" default="Search" /></button>
                 * @param searchUrl - URL to collect the data
                 * @param searchParams - ng Model that contains search params
                 */
                this.getSearchData = function(){
                    logObj.logTab('getSearchData', [this.url,this.paramsModel]);
                    //getSearchData(searchUrl,searchParams);
                    this.ajaxState = ajaxStateOption.LOADING;
                    ajaxCall.getData(this.url, this.paramsModel).then(function (response) {
                        logObj.log('getSearchData() response.data',response.data);
                        _this.responseData = response.data;
                        filterDataService.createFilteredDataList( _this.responseData, _this.cellCache, _this.cellCache );
                        //download all filename doesn't change
                        _this.downloadAllFilename = i18nService.msgByDefault('All {0} Rows',[_this.responseData.dataList.length]);
                        updateDownloadFilteredFilename();
                        _this.ajaxState = ajaxStateOption.COMPLETED;
                    }, function (response) {
                        console.error('AJAX Fail:', response.data);
                        _this.ajaxState = ajaxStateOption.FAILED;
                    });
                    logObj.logTab('getSearchData', [this.url,this.paramsModel], 'data being collected');
                };

                var updateDownloadFilteredFilename = function(){
                    _this.downloadFilteredFilename = i18nService.msgByDefault('Filtered {0} Rows', [_this.responseData.filteredDataList.length]);
                };

                /**
                 *  Filters the data based upon the End User's selected filters.
                 */
                this.filterAndFormatData = function(){
                    logObj.logTab('getSearchData', [this.url,this.paramsModel]);
                    filterDataService.filterAndFormatData( _this.responseData, _this.cellCache, _this.cellCache );
                    updateDownloadFilteredFilename();
                    logObj.logTab('getSearchData', [this.url,this.paramsModel]);
                };

                /**
                 *  Downloads a CSV of the data based upon the End User's selected filters.
                 */
                this.downloadFiltered = function(){
                    logObj.logTab('downloadFiltered',[this.responseData.filteredDataList.length, this.responseData.dataList.length]);
                    filterDataService.download( this.responseData, true, this.downloadFilteredFilename, true, true, _this.cellCache);
                    logObj.logTab('downloadFiltered',[],true);
                };

                /**
                 *  Downloads a CSV of the data based upon the End User's selected filters.
                 */
                this.downloadAll = function(){
                    logObj.logTab('downloadAll');
                    filterDataService.download( this.responseData, false, this.downloadAllFilename, true, true, _this.cellCache);
                    logObj.logTab('downloadAll',true);
                };

                setupI18n();
                setupAttrs();
            },
            transclude: true,
            replace: true,
            template: $templateCache.get('components/xmsSmarterTable.html') // WEBAPP_PATH + '/js/angular/src/components/xmsSmarterTable.html'
        };
    };
    xmsSmarterTable.$inject = ['$compile','$templateCache','logService','i18nService','ajaxCall','filterDataService'];
    angular.module('app').directive('xmsSmarterTable', xmsSmarterTable);
}());
